import { render, staticRenderFns } from "./EpochSelectorItem.vue?vue&type=template&id=4254bc22&"
import script from "./EpochSelectorItem.vue?vue&type=script&lang=js&"
export * from "./EpochSelectorItem.vue?vue&type=script&lang=js&"
import style0 from "./EpochSelectorItem.vue?vue&type=style&index=0&id=4254bc22&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports